import { AshbyLogoIcon, MenuBoardIcon } from '../../assets/icons/common';
import { JobDetail, JobDetailStep } from '../../store/workspace/types';
import { setJobDetailStep } from '../../store/workspace/slice';
import { useDispatch } from '../../store/store';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';
import Button from '../Button';

interface Props {
    jobDetail: JobDetail;
};

export default function CodingExamCard(props: Props) {
    const { jobDetail } = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const getDeadline = () => {
        if (!jobDetail.multipleChoiceExamDeadline) return null;

        const [month, day, year] = jobDetail.multipleChoiceExamDeadline.split('-');
        const deadline = new Date(Number(year), Number(month) - 1, Number(day));
        const today = new Date();
        const diffTime = deadline.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays <= 10 && diffDays > 0
            ? <b data-text-color='red'>({`${diffDays} day${diffDays > 1 ? 's' : ''} left`})</b>
            : null
    };

    const startExam = (jobDetailStep: JobDetailStep) => {
        dispatch(setJobDetailStep(jobDetailStep));
        navigate(`/workspace/exams/${jobDetail.id}?tab=codingExam`);
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <div className={styles.company_detail}>
                    <div className={styles.company_detail_logo}>
                        {jobDetail.companyLogo ? <img src={jobDetail.companyLogo} alt="" /> : <span>{jobDetail.companyName?.slice(0, 1)}</span>}
                    </div>
                    <div className={styles.company_detail_name}>
                        <span>{jobDetail.companyName}</span>
                        {jobDetail.platform === 'Ashby' && <AshbyLogoIcon width={71} height={23} />}
                    </div>
                </div>
                {jobDetail.multipleChoiceExamDeadline &&
                    <div className={styles.deadline}>
                        <MenuBoardIcon />
                        <span>Deadline: </span>
                        <b>{jobDetail.multipleChoiceExamDeadline}</b>
                        {getDeadline()}
                    </div>}
            </div>
            <div className={styles.job_detail}>
                <div className={styles.row}>
                    <span className={styles.row_text} data-is-bold="true">{jobDetail.title}</span>
                </div>
                <div className={styles.row}>
                    <span className={styles.row_text}>Job type: {jobDetail.jobType.title}</span>
                </div>
                <div className={styles.row}>
                    <span className={styles.row_text}>
                        Base salary amount: {jobDetail.baseSalaryAmount || '---'}$ /{jobDetail.baseSalaryFrequency.title}
                    </span>
                </div>
                <div className={styles.row}>
                    <span className={styles.row_text}>
                        {jobDetail.city?.city} / {jobDetail.state?.state} / {jobDetail.country?.title}
                    </span>
                </div>
            </div>
            <div className={styles.actions}>
                <Button
                    type='Primary'
                    className={styles.actions_btn}
                    text='Start coding exam'
                    onClick={() => startExam('Rules')}
                />
                <Button
                    type='Outline-Primary'
                    text='Job description'
                    className={styles.actions_btn}
                    onClick={() => startExam('JobDetail')}
                />
            </div>
        </div>
    )
};
